__turbopack_context__.v({
  "buyLink": "Card-module__0ByagG__buyLink",
  "cardContainer": "Card-module__0ByagG__cardContainer",
  "description": "Card-module__0ByagG__description",
  "filler": "Card-module__0ByagG__filler",
  "imgContainer": "Card-module__0ByagG__imgContainer",
  "textContainer": "Card-module__0ByagG__textContainer",
  "title": "Card-module__0ByagG__title",
});
